var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("document-input", { attrs: { recipient: _vm.recipient } }),
      _c("name-input", { attrs: { recipient: _vm.recipient } }),
      _c("birthdate-input", { attrs: { recipient: _vm.recipient } }),
      _c("email-input", { attrs: { recipient: _vm.recipient } }),
      _c("professional-occupation-input", {
        attrs: { recipient: _vm.recipient },
      }),
      _c("monthly-income-input", { attrs: { recipient: _vm.recipient } }),
      _c("mother-name-input", { attrs: { recipient: _vm.recipient } }),
      _c(
        "div",
        { staticClass: "phone-container" },
        [
          _c("phone-type-input", {
            staticClass: "phone-type",
            attrs: { recipient: _vm.recipient, disabled: _vm.disabled },
          }),
          _c("phone-area-number-input", {
            staticClass: "phone-area",
            attrs: { recipient: _vm.recipient, disabled: _vm.disabled },
          }),
          _c("phone-number-input", {
            staticClass: "phone-number",
            attrs: { recipient: _vm.recipient, disabled: _vm.disabled },
          }),
        ],
        1
      ),
      _c("hr", { staticClass: "emd-divider eu-mb_5" }),
      _c("address-section", {
        attrs: { recipient: _vm.recipient, showSideBlock: false },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }